export default __webpack_public_path__ + "static/media/avatar_151.42f40815.png";